export const PAGINATION_WRAPPER_ID = 'pagination-wrapper';

export const PRODUCT_CARD_GRID_ITEM__DIV = 'PRODUCT_CARD_GRID_ITEM__DIV';
export const PRODUCT_CARD_GRID_ITEM_ID = 'PRODUCT_CARD_GRID_ITEM';
